












// vendor
import { defineComponent } from "@vue/composition-api";
// project
import { RunForm } from "@/components.run/run-form";
// local
import { getProps } from "../../ts/NodeComponent";

type FormParams = {};

export default defineComponent({
	
	emits:[ "end", "previous" ],
	components:{
		RunForm
	},
	props:getProps<FormParams>(),
	setup(props, context){

		const onEnd = () => context.emit("end");
		const onBack = () => context.emit("previous");

		return {
			onEnd,
			onBack
		};

	}
});
